import { CookieNames, getCookie } from '../helpers/cookie.helper';
import axios from './axiosConfig';

export const getAllCompaniesList = async (params = {
    PageIndex: 1,
    PageSize: 100,
    SearchText: '',
    PlanFilter: '',
}) => {
    try {
        const response = await axios.get(`/api/CompanyMaster/GetAllCompaniesList`, {
            params: {
                ...params,
                SessionId: getCookie(CookieNames.SESSION_ID),
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const insertUpdateCompanyMaster = async (formData) => {
    try {
        const response = await axios.post(
            `/api/CompanyMaster/InsertUpdateCompanyMaster`,
            formData,
            {
                params: { SessionId: getCookie(CookieNames.SESSION_ID) },
                headers: { 'Content-Type': 'multipart/form-data' }
            }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const getCompanyDetails = async (companyId) => {
    try {
        const response = await axios.get(`/api/CompanyMaster/GetCompanyMaster`, {
            params: {
                Id: companyId,
                SessionId: getCookie(CookieNames.SESSION_ID),
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const resendActivationEmail = async (companyId) => {
    try {
        const response = await axios.post(
            `/api/CompanyMaster/ResendActivationEmail`,
            {},
            {
                params: { Id: companyId, SessionId: getCookie(CookieNames.SESSION_ID) },
            }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const extendTrialPeriod = async (companyId, newTrialEndDate) => {
    try {
        const response = await axios.post(
            `/api/CompanyMaster/ExtendTrialPeriod`,
            {},
            {
                params: { Id: companyId, NewTrialEndDate: newTrialEndDate, SessionId: getCookie(CookieNames.SESSION_ID) },
            }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}


export const updateCompanyStatus = async (data) => {
    try {
        const response = await axios.post(
            `/api/CompanyMaster/UpdateCompanyStatus`,
            data,
            {
                params: { SessionId: getCookie(CookieNames.SESSION_ID) },
            }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}


export const validateCompanyDomain = async (domain) => {
    try {
        const response = await axios.post(
            `/api/CompanyMaster/ValidateCompanyDomain`,
            {},
            {
                params: { domainName: domain, SessionId: getCookie(CookieNames.SESSION_ID) },
            }
        );
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const getCompanyAdminHistory = async (params = {
    PageIndex: 1,
    PageSize: 100,
    Id: 0,
}) => {
    try {
        const response = await axios.get(`/api/CompanyMaster/GetCompanyAdminHistory`, {
            params: {
                ...params,
                SessionId: getCookie(CookieNames.SESSION_ID),
            }
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}